import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import "./style.scss";
import { splashBackground } from "../../utils/svg_assets";
import { connect, useDispatch } from "react-redux";
import { Base } from "../../components/RootLayout";
import { getBuildDate } from "../../utils/utilities";
import * as PageRoutes from "../../utils/route_pages";
import packageJson from "../../../package.json";
import { setLocalStorage } from "../../utils/utilities";
import ApiUtils from "../../utils/api_utils";
import useWhiteLabel from "../../hooks/useWhiteLabel";

const SplashScreen = (props) => {
  const { setLoginData, setProfile, getDataOrgBySlug, orgData = {} } = props;
  const [searchParams] = useSearchParams();
  const [data, setData] = useState({});
  const { slug } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useWhiteLabel(data);

  useEffect(() => {
    handleProcess();
    if (slug) {
      setLocalStorage("slug", slug);
      getDataOrgBySlug(slug).then((response) => {
        if (response.status === 200) {
          setLocalStorage("orgData", JSON.stringify(response.data));
        }
      });
    } else {
      dispatch.LoginSM.setLoginData({ orgData: {} });
      localStorage.removeItem("orgData");
      localStorage.removeItem("slug");
    }
  }, []);

  const handleProcess = async () => {
    let pwa_token = searchParams.get("pwa_token");
    if (pwa_token) {
      await props
        .loginWithToken({ pwa_token: pwa_token })
        .then(function (response) {
          // const data = LoginDM.fromJson(response.data)
          const data = response.data;
          let orgData = {};

          const { is_whitelabel: isWhitelabel } = data.pwa_settings;

          if (isWhitelabel) orgData = data.pwa_settings;

          setLoginData({
            login: data,
            token: data.token,
            orgData,
          });

          setData({ data: data.pwa_settings });
          setProfile({ profile: data.user_details });
          setTimeout(() => {
            // data.organization_pwa_settings.redirect = 3;
            switch (data.organization_pwa_settings.redirect) {
              case 3:
                navigate(PageRoutes.reward, { replace: true });
                break;
              default:
                navigate(PageRoutes.home, { replace: true });
                break;
            }
          }, 500);
        })
        .catch(function (error) {
          navigate(PageRoutes.login, { replace: true });
        });
    } else {
      let timer = setTimeout(() => {
        const { profile } = props;
        if (profile && profile.token) {
          const { organization_pwa_settings } = profile;
          // organization_pwa_settings.redirect = 3;
          switch (organization_pwa_settings.redirect) {
            case 3:
              navigate(PageRoutes.reward, { replace: true });
              break;
            default:
              navigate(PageRoutes.home, { replace: true });
              break;
          }
        } else {
          if (slug) {
            navigate(`${PageRoutes.loginOrgBySlug}/${slug}`, { replace: true });
          } else {
            navigate(PageRoutes.login, { replace: true });
          }
        }
      }, 2 * 1000);

      return () => {
        clearTimeout(timer);
      };
    }
  };

  return (
    <Base>
      <Container
        className="vh-100 w-100 zeropm"
        style={{
          backgroundImage: `url(${
            Object.keys(orgData).length > 0
              ? ApiUtils.validateImgUrl({
                  url: orgData.splash_screen,
                })
              : splashBackground
          })`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
        fluid
      >
        <div className="version">
          <center>
            <span>Version {packageJson.version}</span>
          </center>
        </div>
        <div className="build-date">
          Build date: {getBuildDate(packageJson.buildDate)}
        </div>
      </Container>
    </Base>
  );
};

const mapStateToProps = (state) => ({
  profile: state.LoginSM.login,
  orgData: state.LoginSM.orgData,
});

const mapDispatchToProps = (dispatch) => ({
  loginWithToken: dispatch.LoginSM.loginWithToken,
  setLoginData: dispatch.LoginSM.setLoginData,
  setProfile: dispatch.ProfileSM.setProfile,
  getDataOrgBySlug: dispatch.LoginSM.getDataOrgBySlug,
});

export default connect(mapStateToProps, mapDispatchToProps)(SplashScreen);
